import { APP_BASE_URL } from 'constants';
import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from 'store/auth';

const ProtectedRoute = ({ allowedRoles }: any) => {
	const roleType = useAuthStore((state) => state?.previewsRole);
	const { token: isAuthenticated, user }: Record<string, any> = useAuthStore(
		(state) => state.userInfo ?? {},
	);

	if (!isAuthenticated) {
		window.location.replace(`${APP_BASE_URL}/login?userType=${roleType}`);
		return;
	}

	if (allowedRoles && !allowedRoles.includes(user?.userType)) {
		return <Navigate to="/unauthorized" />;
	}

	return <Outlet />;
};

export default ProtectedRoute;
